import { ProductDetailPage } from '@/components/products/product-detail-page';
import { cancerNavigatorProduct } from '@/content/products';

export function CancerNavigatorPage() {
  return <ProductDetailPage product={cancerNavigatorProduct} />;
}
